<template>
    <b-modal id="causeCancelOrder" :title="modalTitle" centered ref="causeCancelOrder" cancel-title="Отмена" @shown="cancelCause = ''" @ok="cancelOrder"
             ok-title="ОК">
        <b-form-group
                label="Введите причину отмены заказа:"
                class="mb-0 flex-grow-0"
                label-for="InputCause">
            <b-form-input id="InputCause"
                          v-model="cancelCause"
                          class=""
                          required
                          trim
                          placeholder="Комментарий">
            </b-form-input>
            <div class="">
                <b-button variant="outline-primary" class="mt-2 mr-2" v-for="cause in cancelCauses" :key="cause" @click="cancelCause = cause">{{cause}}</b-button>
            </div>
        </b-form-group>
    </b-modal>
</template>

<script>
import commonForOrderQueries from '../../graphql/commonForOrders'
import {
  USER_ROLE_CALL_CENTER,
  USER_ROLE_LOGISTICIAN
} from '../../constants/roles'

export default {
  name: 'CancelOrder',
  data () {
    return {
      cancelCause: '',
      modalTitle: ''
    }
  },
  computed: {
    cancelCauses () {
      if (this.$userControl.jwtParsed) {
        switch (this.$userControl.jwtParsed.role) {
          case USER_ROLE_CALL_CENTER:
            return [
              'Отказ гостя',
              'Не устроило время ожидания',
              'Не открыли дверь',
              'Не дозвонились',
              'Тестовый заказ'
            ]
          case USER_ROLE_LOGISTICIAN:
            return ['Клиент не приехал']
        }
      }
      return []
    }
  },
  props: {
    orderId: Number,
    statusOptions: Array,
    repeat: Boolean,
    onWorkshopNow: Boolean
  },
  methods: {
    modalTitleHandler () {
      let message = 'Вы действительно хотите отменить заказ?'
      if (this.onWorkshopNow === true) {
        message += ' Внимание!!! Данный заказ уже готовится в цехах.'
      }
      this.modalTitle = message
    },
    showModalCancel () {
      this.modalTitleHandler()
      this.$refs.causeCancelOrder.show()
    },
    cancelOrder (evt) {
      evt.preventDefault()
      if (this.cancelCause !== '') {
        this.cancelOrderMutate(this.cancelCause)
        this.$nextTick(() => {
          this.$bvModal.hide('causeCancelOrder')
        })
      } else {
        alert('Сначала введите причину отмены')
      }
    },
    cancelOrderMutate (cancelComment) {
      // let canceledStage = this.statusOptions.find(el => el.keyword === STATUS_ORDER.CANCELED)
      let rep = Boolean(this.repeat)
      this.$apollo.mutate({
        mutation: commonForOrderQueries.CANCEL_ORDER,
        variables: {
          idOrder: this.orderId,
          cancelComment: cancelComment,
          repeatingOrder: rep
        }
      }).then((data) => {
        this.$emit('order-canceled', this.orderId)
      }).catch((error) => {
        console.error(error)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/CancelOrder.vue